import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'

import removeHyphen from '@/helpers/removeHyphen'

import type { TODO } from '@/types'

export const emptyCoordinatorQuestionnaire = (): TODO => ({
  inclusionReason: null,
  personalDifficulties: [],
  personalDifficultiesOther: null,
  activities: null,
  strength: null,
  previousEditions: null,
  numberOfEditions: null,
  programHelp: null,
  environmentalIssues: [],
  numberOfSiblings: null,
  sickFamilyMembers: null,
  familySchoolImpact: null,
  environmentalIssuesOther: null,
  incompleteFamily: [],
  incompleteFamilyOtherDescription: null,
  learningIssues: [],
  learningIssuesSpecificSchoolClass: null,
  peersIssues: [],
  peersIssuesOther: null,
  schoolCommitment: null,
  mentalEvaluation: null,
  mentalEvaluationDescription: null,
  schoolCoordinatorAdvice: null,
  otherInformationAffectingSchoolFunctioning: null,
  attendPsychologicalOrPedagogicalTherapy: null,
  attendPsychologicalOrPedagogicalTherapyDescription: null,
  childBehaviorPreventSafeWork: null,
  childBehaviorPreventSafeWorkDescription: null
})

export const prepareData = (payload: TODO) => {
  if (payload) {
    const copiedPayload = { ...payload }
    let preparedData = copiedPayload.data
    preparedData = omitBy(preparedData, isNil)
    preparedData = omitBy(preparedData, (value) => value.length === 0)
    if (copiedPayload?.documentType === 'guardian_consent') {
      preparedData = {
        ...preparedData?.address,
        ...preparedData?.childApplication,
        ...preparedData?.extraField,
        ...preparedData?.parentInfo
      }
      preparedData.postalCode = removeHyphen(preparedData?.postalCode)
    }
    if (copiedPayload?.documentType === 'dream_drawing') {
      const formData = new FormData()
      formData.append('likeDescription', preparedData?.likeDescription)
      if (preparedData.drawing) formData.append('drawing', preparedData?.drawing)
      preparedData = formData
    }
    copiedPayload.data = preparedData
    return copiedPayload
  }
  return {}
}
